import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type WorkspaceSidebarBoardsListItemButtonProps = ComponentPropsWithoutRef<'button'>;

export const WorkspaceSidebarBoardsListItemButton = memo(
  forwardRef<HTMLButtonElement, WorkspaceSidebarBoardsListItemButtonProps>(({ className, ...restOfProps }, ref) => {
    return (
      <button
        className={cn(
          'flex size-6 shrink-0 items-center justify-center rounded-4 ads:text-icon-default text-gray-10 outline-none ads:hover:bg-hover-subtle hover:bg-gray-4 ads:focus-visible:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9 focus-visible:ring-inset active:bg-gray-4 ads:active:bg-hover-subtle disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        type="button"
        {...restOfProps}
      />
    );
  }),
);

WorkspaceSidebarBoardsListItemButton.displayName = 'WorkspaceSidebarBoardsListItemButton';
